module.exports = __webpack_public_path__ + "static/img/qingduwumai.6d89d7c3.png";